export default __webpack_public_path__ + "static/media/networkflow.0b5b1a6b.png";